const { translateString } = window.BAO.Utils

class WishlistRemoveProduct extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.wishlistError = this.wishlistError.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
  }

  handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-remove-product-external-el="trigger"]',
    )

    if (!trigger) return

    const { wishlistId, productId, variantId, productUrl, productTitle } =
      trigger.dataset

    this.els.submit.element.dataset.wishlistId = wishlistId
    this.els.submit.element.dataset.productId = productId
    this.els.submit.element.dataset.variantId = variantId
    this.els.submit.element.dataset.productUrl = productUrl

    this.els.text.element.innerHTML = translateString(
      this.translations?.wishlist?.removeProduct?.text ?? '',
      {
        title: String(productTitle ?? ''),
      },
    )
  }

  handleSubmit () {
    const { wishlistId, productId, variantId, productUrl } =
      this.els.submit.element.dataset

    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }

    window._swat.deleteFromList(
      wishlistId,
      product,
      () => {
        window.drawers.activeDrawerKey = ''

        window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.LISTS_CHANGED)
      },
      this.wishlistError,
    )
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.error(`Wishlist error: ${errorMessage}`);
  }

  get translations () {
    return window.theme ?? {}
  }
}

if (!customElements.get('wishlist-remove-product')) {
  customElements.define('wishlist-remove-product', WishlistRemoveProduct)
}
